<template>
  <div class="input-evaluation">
    <div v-if="type === 'text' && edit">
      <input type="text" class="form-control" :name="name" :value="value" />
    </div>
    <div v-if="type === 'textarea' && edit">
      <textarea :name="name" class="form-control" :value="value"></textarea>
    </div>
    <div v-if="!edit">
      <p class="value-text">{{ value }}</p>
    </div>
    <div class="approval" v-if="!edit">
      <label :class="{ option: true, accept: true, active: approval == '1' }" title="Aprovar">
        <input type="radio" name="approval" value="1" v-model="approval">
        <i class="fa fa-thumbs-o-up" aria-hidden="true"></i>
      </label>
      <label :class="{ option: true, reject: true, active: approval == '0' }" title="Reprovar">
        <input type="radio" name="approval" value="0" v-model="approval">
        <i class="fa fa-thumbs-o-down" aria-hidden="true"></i>
      </label>
      <div :class="{'form-group': true, active: approval == '0'}">
        <label>Motivo da reprovação</label>
        <input type="text" name="motivo" class="form-control">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "type", "name", "edit"],
  data() {
    return {
      approval: null
    }
  },
  mounted() {
    console.log("Component mounted.");
  }
};
</script>

<style lang="scss">
.input-evaluation {
  textarea {
    width: 100%;
    height: 75px;
  }

  .value-text {
    font-weight: bold;
    text-align: left;
    margin: 8px 0;
    font-size: 13px;
  }

  .approval {
    text-align: left;

    .option {
      display: inline-block;
      font-size: 22px;
      opacity: .6;
      cursor: pointer;

      input[type="radio"] {
        visibility: hidden;
        height: 0;
        margin: 0;
        width: 0;
      }

      &.accept {
        color: green;
      }

      &.reject {
        color: red;
      }

      &.active {
        opacity: 1;
      }
    }

    .form-group {
      max-height: 0;
      overflow: hidden;
      transition: max-height .5s;

      &.active {
        max-height: 100px;
      }
    }
}
}
</style>
